<template>
  <v-layout align-center column >
    <p class="Section-Title">Pertanyaan Seputar Pendanaan</p>
    <div style="width:320px;">
      <v-divider></v-divider>
       <pertanyaan-content-mobile v-for="data in questions" :data="data" :key="data"/>
     

    </div>
  </v-layout>
</template>
<script>
import PertanyaanContentMobile from './PertanyaanContentMobile.vue';

export default {
    components: {  PertanyaanContentMobile },

  data(){
    return {
      size: 0,
      widthComponent: 0,
      questions: [
        {
        title: "Apakah melakukan pendanaan di Dompet Kilat aman?",
        detail: ` Aman. Dompet Kilat diawasi dan memiliki izin operasional dari OJK. Dompet Kilat juga tersertifikasi ISO:27001 tentang sistem manajemen keamanan informasi.`,
        visible: true
      },
       {
        title: "Apa itu ekosistem supply chain financing?",
        detail: `Dompet Kilat hanya memberikan pinjaman pada mitra usaha yang sudah tergabung dalam kelompok binaan yang memiliki rantai pasokan yang jelas dalam industrinya.`,
        visible: false
      },
      {
        title: "Siapa saja yang dapat menjadi pendana di Dompet Kilat?",
        detail: `Siapa saja yang memiliki KTP Indonesia.`,
        visible: false
      },
      {
        title: "Apakah berinvestasi di Dompet Kilat pasti untung?",
        detail: `Tidak. Semua jenis investasi memiliki risikonya masing-masing.`,
        visible: false
      },
      {
        title: "Bagaimana kalau peminjam gagal bayar?",
        detail: `Dompet Kilat memilih dengan ketat mitra usaha yang dibiayai melalui ekosistem dan menjaminnya dengan asuransi. Namun, risiko tetap ada.`,
        visible: false
      },
      ]
    }
  },
  
};
</script>
<style scoped>
.Section-Title {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 0 0 31px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}


</style>
